import { apiClient } from '../../axios';
import { GetVouchersParams, GetVouchersResponse, VoucherType } from './types';

export const getVouchersApi = (params?: GetVouchersParams) =>
  apiClient.get<GetVouchersResponse>('/v1/vouchers', {
    params,
    paramsSerializer: (params) => {
      const searchParams = new URLSearchParams();
      for (const [key, value] of Object.entries(params || {})) {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            searchParams.append(key, String(item));
          });
        } else if (value !== undefined && value !== null) {
          searchParams.append(key, String(value));
        }
      }
      return searchParams.toString();
    },
  });

export const postVoucherActivateApi = (type: VoucherType, grantId: number) =>
  apiClient.post(`/v1/vouchers/${type}/${grantId}/activate`);
